module.exports = __webpack_public_path__ + "components/signup-page/static/icon-eye--show-acb03bf8e98028fff3718e0c1c32c6f2.svg";